import { NgModule } from "@angular/core";
import { TurbineListComponent } from "./turbine-list.component";
import { CommonModule } from "@angular/common";
import { ReactiveFormsModule, FormsModule } from "@angular/forms";
import { SharedModule } from "../shared.module";
import { SharedImportsModule } from "../shared/shared-imports.module";
import { TableControlsComponent } from "../shared/table-controls/table-controls.component";
import { TurbineCreateComponent } from "./create/turbine-create.component";
import { TurbineEditComponent } from "./edit/turbine-edit.component";
import { TurbineBulkUploadComponent } from "./bulk-upload/turbine-bulk-upload.component";

const componentList = [
  TurbineListComponent,
  TurbineCreateComponent,
  TurbineEditComponent,
  TurbineBulkUploadComponent,
];

@NgModule({
  imports: [
    SharedImportsModule,
    TableControlsComponent,
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    SharedModule,
  ],
  declarations: [componentList],
  exports: [componentList],
})
export class TurbinesModule {}
